import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { colorStyles } from './colorStyles';
import { sizeStyles } from './sizeStyles';
import { ProgressBar } from '../ProgressBar/ProgressBar';

const ProgressContent = styled.div`
  display: grid;
  grid-template-columns: 36px 46px;
  align-items: center;
  justify-content: flex-start;
  column-gap: 4px;
`;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Container = styled.div`
  border-radius: 6px;
  cursor: pointer;

  ${colorStyles}
  ${sizeStyles}

  &.disabled {
    cursor: not-allowed;
  }
`;

interface ElementNavbarSectionQuestionProps {
  size?: 'normal' | 'small';
  text?: string;
  answeredQuestions?: number;
  totalQuestions?: number;
  active?: boolean;
  disabled?: boolean;
  onClick?: (e?: any) => void;
}

export const ElementNavbarSectionQuestion = (props: ElementNavbarSectionQuestionProps) => {
  const { size, text, answeredQuestions, totalQuestions, active, disabled, onClick } = props;

  const progressBgColor = React.useMemo(() => {
    if (disabled) {
      return colorsV2.black20;
    }
    if (active) {
      return colorsV2.primary20;
    }
    return colorsV2.black20;
  }, [disabled, active]);

  const progressColor = React.useMemo(() => {
    if (disabled) {
      return colorsV2.black20;
    }
    if (active) {
      return colorsV2.primary100;
    }
    return colorsV2.black80;
  }, [disabled, active]);

  if (size === 'small') {
    return (
      <Container
        className={cl('element-navbar-section-question', size, { active, disabled })}
        onClick={(e) => !disabled && onClick?.(e)}
      >
        <Layout>
          <ResponsiveTypography.Paragraph variant="bold/14-18">
            {text}
          </ResponsiveTypography.Paragraph>
        </Layout>
      </Container>
    );
  }

  return (
    <Container
      className={cl('element-entrance-test-navbar-section-question', size, { active, disabled })}
      onClick={(e) => !disabled && onClick?.(e)}
    >
      <Layout>
        <ResponsiveTypography.Paragraph variant="bold/14-18">{text}</ResponsiveTypography.Paragraph>
        <ProgressContent>
          <ResponsiveTypography.Text variant="medium/12-20">
            {`${answeredQuestions}/${totalQuestions}`}
          </ResponsiveTypography.Text>
          <ProgressBar
            percentage={answeredQuestions / totalQuestions}
            bgColor={progressBgColor}
            progressColor={progressColor}
          />
        </ProgressContent>
      </Layout>
    </Container>
  );
};
